<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <dxi-item dataField="poNumber" [label]="{ text: 'PO #' }"></dxi-item>
                    <dxi-item
                        dataField="vendorId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Vendor' }"
                        [editorOptions]="{ items: vendors, valueExpr: 'id', displayExpr: 'companyName' }"
                    ></dxi-item>
                    <dxi-item
                        dataField="statusId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Status' }"
                        [editorOptions]="{ items: statuses, valueExpr: 'id', displayExpr: 'name' }"
                    ></dxi-item>
                    <dxi-item dataField="partNumber" [label]="{ text: 'Part #' }"></dxi-item>
                    <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                    <dxi-item dataField="deliveryStart" editorType="dxDateBox" [label]="{ text: 'Est. Delivery From' }"></dxi-item>
                    <dxi-item dataField="deliveryEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <dxi-item dataField="createdStart" editorType="dxDateBox" [label]="{ text: 'Order From' }"></dxi-item>
                    <dxi-item dataField="createdEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end align-items-center mt-3">
                <div *ngIf="purchaseOrders" class="me-3">{{ purchaseOrders.length }} {{ purchaseOrders.length === 1 ? 'item found' : 'items found' }}</div>
                <button type="button" accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button type="button" (click)="clear()" class="btn btn-light ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div *ngIf="purchaseOrders" class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="purchaseOrders"
            keyExpr="id"
            [columnAutoWidth]="false"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="poNumber" caption="PO #" width="80"></dxi-column>
            <dxi-column dataField="vendorCompanyName" caption="Vendor" width="200" cellTemplate="vendorTemplate"></dxi-column>
            <dxi-column dataField="vendorAddressDisplay" caption="Vendor Address" width="200"></dxi-column>
            <dxi-column dataField="remitAddressDisplay" caption="Remit Address" width="200"></dxi-column>
            <dxi-column dataField="shippingAddressDisplay" caption="Shipping" width="200"></dxi-column>
            <dxi-column dataField="createDate" caption="Order Date" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="estimatedDelivery" caption="Est. Delivery" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
            <dxi-column dataField="summary"  width="100" [encodeHtml]="false" ></dxi-column>
            <dxi-column dataField="deleted" dataType="date" format="shortDate" width="100"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="purchase-order-history-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'vendorTemplate'">
                <a [routerLink]="['/vendors/overview/' + cell.data.vendorId]">{{ cell.value || '' }} </a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="purchaseOrders" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
